export const urlConstants = {
    BACKEND_URL: 'https://8ykuc54eik.execute-api.us-east-1.amazonaws.com/dev/',
    LANDING_URL: 'https://tecmow.com'
};